var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTemp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_924_146602)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_924_146602)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33 32C32.4477 32 32 32.4477 32 33V47C32 47.5523 32.4477 48 33 48H47C47.5523 48 48 47.5523 48 47V33C48 32.4477 47.5523 32 47 32H33ZM30 33C30 31.3431 31.3431 30 33 30H47C48.6569 30 50 31.3431 50 33V47C50 48.6569 48.6569 50 47 50H33C31.3431 50 30 48.6569 30 47V33Z",
    fill: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5 36C36.2239 36 36 36.2239 36 36.5C36 36.7761 36.2239 37 36.5 37C36.7761 37 37 36.7761 37 36.5C37 36.2239 36.7761 36 36.5 36ZM34 36.5C34 35.1193 35.1193 34 36.5 34C37.8807 34 39 35.1193 39 36.5C39 37.8807 37.8807 39 36.5 39C35.1193 39 34 37.8807 34 36.5Z",
    fill: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.2929 37.2929C43.6834 36.9024 44.3166 36.9024 44.7071 37.2929L49.7071 42.2929C50.0976 42.6834 50.0976 43.3166 49.7071 43.7071C49.3166 44.0976 48.6834 44.0976 48.2929 43.7071L44 39.4142L33.7071 49.7071C33.3166 50.0976 32.6834 50.0976 32.2929 49.7071C31.9024 49.3166 31.9024 48.6834 32.2929 48.2929L43.2929 37.2929Z",
    fill: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "url(#pattern0)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_924_146602",
    transform: "scale(0.03125)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_924_146602"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 12,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_924_146602"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_924_146602",
    width: 32,
    height: 32,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAaSURBVHgB7cABAQAAAIIg/69uSFAAAADAuwEQIAABrSYnKgAAAABJRU5ErkJggg=="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemp);
export default __webpack_public_path__ + "static/media/temp.830b296b1d9612ff5f70d290fada9988.svg";
export { ForwardRef as ReactComponent };